import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl, FormControl } from '@angular/forms';

@Directive({
  selector: '[enterTextarea]'
})
export class EnterTextareaDirective {


  constructor(
    public ngControl: NgControl,
    private el: ElementRef,
  ) { }

  @HostListener('document:mousedown', ['$event'])
  onMouseDown(event: any) {
    //this.onInputChange2(event, false)
  }


  @HostListener('ngModelChange', ['$event'])
  onModelChange(event: any) {
    //this.onInputChange(event, false);
  }


  @HostListener('keyup.enter', ['$event'])
  keydownEnter(event: any) {
    //this.onInputChange(event, true);
  }

  @HostListener('keyup', ['$event'])
  keydown(event: KeyboardEvent) {
    this.onInputChange(event, false);
  }


  onInputChange(event: KeyboardEvent, enter: any) {

    var inputEle = this.el.nativeElement as HTMLInputElement;
    let inputVal = inputEle.value;
    if(event.shiftKey && event.key === 'Enter'){
      var start = inputEle.selectionStart ?? 0;
      var end = inputEle.selectionEnd ?? 0;
      var newVal = inputVal.substring(0, start)  + inputVal.substring(end);
      inputEle.value = newVal;
      this.ngControl.control?.setValue(newVal);
    }
    if (!event.shiftKey && event.key === 'Enter') {
      var start = inputEle.selectionStart ?? 0;
      var end = inputEle.selectionEnd ?? 0;
      var newVal = inputVal.substring(0, start) + '\t' + inputVal.substring(end);
      inputEle.value = newVal;
      this.ngControl.control?.setValue(newVal);
    }
    // if (inputVal.trim().length == 0) {
    //   var newVal2 = '\t';
    //   inputEle.value = newVal2;
    //   this.ngControl.control?.setValue(newVal2);
    // }
  }
  onInputChange2(event: KeyboardEvent, enter: any) {

    var inputEle = this.el.nativeElement as HTMLInputElement;
    let inputVal = inputEle.value;
    if (!inputVal) {
      var newVal2 = '\t';
      inputEle.value = newVal2;
      this.ngControl.control?.setValue(newVal2);
    }
  }
}
